import DirectusMultiComboboxBadges from "components/directus/multi-combobox-badges";
import client from "directus/src/client";
import React from "react";
import DepartmentCombobox from "components/directus/department-combobox";
import CalendarDatePicker from "ui/components/comp-507";
import { formatDateForAPI } from "utils/utils";

export default function DepartmentReportFilters({ filters, setFilters }) {
  const fromDate = filters?.startDate ? new Date(filters.startDate) : undefined;
  const toDate = filters?.endDate ? new Date(filters.endDate) : undefined;

  const handleDepartmentChange = (value) => {
    setFilters({
      ...filters,
      departmentId: value,
    });
  };

  const handleDateChange = (newDate) => {
    setFilters({
      ...filters,
      startDate: newDate?.from ? formatDateForAPI(newDate.from) : undefined,
      endDate: newDate?.to ? formatDateForAPI(newDate.to) : undefined,
    });
  };

  return (
    <div className="flex gap-6 items-center">
      <DirectusMultiComboboxBadges
        client={client}
        collection="tags"
        fields={["id", "label", "color", "key"]}
        searchKeys={["label"]}
        filter={{ for: { _eq: "projects" } }}
        sort={["label"]}
        placeholder="Select Tags"
        mapItem={(item) => ({
          value: item.key,
          label: item.label,
          select: item.label,
        })}
        initialValues={filters?.tagIds?.split(',')}
        onValuesChange={(selectedItems) => {
          setFilters({
            ...filters,
            tagIds: selectedItems?.length ? selectedItems.join(',') : undefined,
          });
        }}
      />
      <DepartmentCombobox
        value={filters?.departmentId}
        onChange={handleDepartmentChange}
        hideLabel={true}
      />
      <CalendarDatePicker
        date={{ from: fromDate, to: toDate }}
        setDate={handleDateChange}
      />
    </div>
  );
}
